// UnauthorizedPage.js
import React from 'react';

const UnauthorizedPage = () => {
  return (
    <div>
      <h1>Access Denied</h1>
      <p>You are not authorized to access this resource.</p>
      {/* You can add more details here if needed */}
    </div>
  );
};

export default UnauthorizedPage;